import { getJobs } from "@/getters/getJobs";
import { JobCard } from "@/components/JobCard";
import { Stack } from "react-bootstrap";
import clsx from "classnames";
import classes from "./styles.module.scss";

export const LatestJobs = ({ className, limit }) => {
  const items = getJobs({ limit });

  return (
    <div className={clsx(className, classes.jobs)}>
      <h4 className="mb-4">Latest Jobs</h4>
      <Stack gap={4}>
        {items.map((i) => (
          <JobCard className={classes.jobs__card} key={i.id} {...i} buttonVariant="blue" />
        ))}
      </Stack>
    </div>
  );
};

LatestJobs.defaultProps = {
  limit: 5,
};
